export const GEOLOCATION_MODULE_TYPES = {
  DEFAULT_MODULE_TYPE: 'default',
  OPTIONAL_MODULE_TYPE: 'optional'
};
